(function() {

    'use strict';

    eclipseApp.factory('prepaidRefillRedeemVoucherService', function() {

        var voucher = {};

        function setVoucher(data) {
            voucher = data;
        }

        function getVoucher() {
            return voucher;
        }

        return {
            setVoucher: setVoucher,
            getVoucher: getVoucher
        };

    });

})();
